import { Stack, Typography } from "@mui/material";
import { SteelGradeChip } from "components/common/chips/steelGrade";
import { useBaskets } from "contexts/search/SearchContextProvider";
import { useTenantTranslation } from "hooks/formatters";
import { ChemicalConstraints } from "src/components/common/chemicalConstraints";
import { useTenantData } from "src/contexts/tenant";
import {
  ChemicalConstraint,
  ChemicalElement,
  SteelGrade,
} from "store/api/generatedApi";
import { MaterialLimitsPanel } from "./MaterialLimits";

export const MixDetailsPropertiesTab = ({
  chemicalConstraints,
  defaultTargetNumberOfBaskets,
  maximumFailureRate,
  elements,
  steelGrades,
  chefGroupId,
}: {
  chemicalConstraints: ChemicalConstraint[];
  steelGrades: SteelGrade[];
  defaultTargetNumberOfBaskets: number;
  maximumFailureRate: number;
  elements: Record<number, ChemicalElement>;
  chefGroupId: number;
}) => {
  const { t } = useTenantTranslation();
  const baskets = useBaskets();
  const tenantData = useTenantData();
  const impurity_plot_type = tenantData.impurity_plot_type;

  return (
    <Stack gap={3} sx={{ py: 2 }}>
      <Stack gap={1}>
        <Typography>{t("chemicalTolerances")}</Typography>
        <Stack gap={0.5} flexDirection="row" flexWrap="wrap">
          <ChemicalConstraints
            chemicalConstraints={chemicalConstraints}
            elements={elements}
          />
        </Stack>
      </Stack>
      <Stack gap={1}>
        <Typography>{t("defaultNumBaskets")}</Typography>
        <Typography>{defaultTargetNumberOfBaskets}</Typography>
      </Stack>
      {impurity_plot_type !== "bar" && (
        <Stack gap={1}>
          <Typography>{t("maximumFailureRate")}</Typography>
          <Typography>{maximumFailureRate}</Typography>
        </Stack>
      )}
      <Stack gap={1}>
        <Typography>{t("steelGrades")}</Typography>
        <Stack gap={0.5} flexDirection="row" flexWrap="wrap">
          {steelGrades.map(({ id, name, chemical_constraints }) => (
            <SteelGradeChip
              key={id}
              id={id}
              name={name}
              chemicalConstraints={chemical_constraints}
            />
          ))}
        </Stack>
      </Stack>
      <Stack gap={1}>
        <Typography>{t("materialLimits")}</Typography>
        <MaterialLimitsPanel chefGroupId={chefGroupId} basket={null} />
        {baskets.status === "success"
          ? baskets.data.map((basket) => (
              <MaterialLimitsPanel
                key={basket.id}
                chefGroupId={chefGroupId}
                basket={basket}
              />
            ))
          : null}
      </Stack>
    </Stack>
  );
};
